export default "__VITE_ASSET__DE0V7udv__"